var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassificationGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.956 30.3262C138.602 30.9302 139.117 31.6606 139.469 32.4721C139.82 33.2836 140.001 34.1587 140 35.0431V115.4C140.001 116.249 139.834 117.09 139.51 117.875C139.185 118.66 138.709 119.372 138.109 119.973C137.508 120.573 136.796 121.049 136.011 121.374C135.226 121.699 134.385 121.865 133.536 121.864H21.9665C20.6785 121.866 19.4196 121.482 18.3525 120.76",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.644 28.4053H14.8553C12.1738 28.4053 10 30.5791 10 33.2606V111.117C10 113.799 12.1738 115.973 14.8553 115.973H129.644C132.326 115.973 134.5 113.799 134.5 111.117V33.2606C134.5 30.5791 132.326 28.4053 129.644 28.4053Z",
    fill: "#CDD9E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9743 50.1943H38.4878V57.0302H84.9743V50.1943Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.123 50.1943H103.18V57.0302H115.123V50.1943Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.123 83.8315H103.18V90.6674H115.123V83.8315Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.089 67.0127H103.18V73.8486H119.089V67.0127Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.649 100.65H103.18V107.486H118.649V100.65Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1389 36.9575H38.4878V41.2318H64.1389V36.9575Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.089 37.0693H103.18V41.235H119.089V37.0693Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7058 67.0488H38.4878V73.812H76.7058V67.0488Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5888 83.8682H38.4878V90.6313H87.5888V83.8682Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2536 100.687H38.4878V107.45H82.2536V100.687Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5776 44.6304H126.561",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4878 61.6807H126.561",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5776 78.7305H126.561",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4878 95.7808H126.561",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8241 87.1792H26.5232C26.7797 87.1792 27.0258 87.2812 27.2072 87.4626C27.3886 87.644 27.4906 87.8901 27.4906 88.1466V95.3037H24.8794V88.1239C24.8794 87.8734 24.9789 87.6331 25.1561 87.4559C25.3333 87.2788 25.5735 87.1792 25.8241 87.1792Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4542 95.355H20.9165V97.6941H31.4542V95.355Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6143 97.6938H30.7566V103.469C30.7566 103.589 30.733 103.708 30.6871 103.818C30.6412 103.929 30.5739 104.03 30.4891 104.115C30.4042 104.2 30.3035 104.267 30.1927 104.313C30.0819 104.359 29.9631 104.382 29.8431 104.382H22.4645C22.3528 104.382 22.2423 104.36 22.1391 104.318C22.036 104.275 21.9422 104.212 21.8633 104.133C21.7843 104.054 21.7217 103.961 21.679 103.857C21.6362 103.754 21.6143 103.644 21.6143 103.532V97.6938Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.791 100.186V104.246",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.606 100.186V104.246",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5525 65.0777V68.7493H27.6591V65.0777C28.8862 64.7052 29.9386 63.9043 30.6245 62.8208C31.3104 61.7373 31.5841 60.4435 31.3958 59.1751C31.2076 57.9066 30.5698 56.7481 29.5988 55.9106C28.6278 55.073 27.3881 54.6123 26.1058 54.6123C24.8235 54.6123 23.5838 55.073 22.6128 55.9106C21.6418 56.7481 21.004 57.9066 20.8158 59.1751C20.6275 60.4435 20.9013 61.7373 21.5872 62.8208C22.2731 63.9043 23.3255 64.7052 24.5525 65.0777Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8481 60.1025L26.1055 61.7269V66.4552",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.106 61.727L27.2698 60.1025",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5527 66.4546H27.6594",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassificationGrey);
export default __webpack_public_path__ + "static/media/classification_grey.5fe220423c345b023f5283bd0762c427.svg";
export { ForwardRef as ReactComponent };